import React, { useState } from 'react';
import Datatable from '../../../components/Datatable';
import { MenuItem, Select, TextField, Box } from '@mui/material';
import moment from 'moment';
import EmpresaSelect from '../../../components/EmpresaSelect';

const getItem = (storage, key) => {
    const data = localStorage.getItem(storage)
    return data ? Object.keys(JSON.parse(data)).includes(key) ? JSON.parse(data)[key] : null : null
}

export default function Queue() {
    const [empresa, setEmpresa] = useState(getItem('hermes', 'empresa') || null)
    const [refresh, setRefresh] = useState(false)
    const [active, setActive] = useState(true)
    const [dateFrom, setDateFrom] = useState('')
    const [dateTo, setDateTo] = useState('')

    React.useEffect(() => {
        document.title = "IPV7 Hermes - Fila de Execução de Backup"
    }, [])

    return (
        <Datatable
            empresa={empresa}
            refresh={refresh}
            handlerRefresh={() => setRefresh(!refresh)}
            title='Fila de Execução de Backup'
            endpoint={`/admin/hermes/queue?active=${active ? 1 : 0}`}
            filters={{ date_from: dateFrom || null, date_to: dateTo || null }}
            options={{
                customToolbar: () => (
                    <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                        <EmpresaSelect
                            sx={{ width: '400px' }}
                            value={empresa}
                            handler={(e) => {
                                localStorage.setItem('hermes', JSON.stringify({ empresa: e }))
                                setEmpresa(e)
                            }}
                        />
                        <TextField
                            type="date"
                            size="small"
                            label="De"
                            value={dateFrom}
                            onChange={(e) => setDateFrom(e.target.value)}
                            InputLabelProps={{ shrink: true }}
                            sx={{ width: 150 }}
                        />
                        <TextField
                            type="date"
                            size="small"
                            label="Até"
                            value={dateTo}
                            onChange={(e) => setDateTo(e.target.value)}
                            InputLabelProps={{ shrink: true }}
                            sx={{ width: 150 }}
                        />
                        <Select
                            value={active}
                            size='small'
                            onChange={(e) => {
                                setActive(e.target.value)
                                setRefresh(true)
                            }}
                        >
                            <MenuItem value={true}>Ativo</MenuItem>
                            <MenuItem value={false}>Inativo</MenuItem>
                        </Select>
                    </Box>
                ),
                customToolbarSelect: () => ""
            }}
            columns={[
                {
                    name: 'id',
                    label: "ID",
                    options: {
                        filter: false,
                        sort: false,
                        display: false
                    }
                },
                {
                    name: 'empresa_name',
                    label: 'Empresa',
                },
                {
                    name: 'host_name',
                    label: "Nome",
                },
                {
                    name: "ip_address",
                    label: 'IP',
                    options: {
                        sort: false,
                    }
                },
                {
                    name: "vendor",
                    label: 'Marca',
                    options: {
                        sort: false,
                    }
                },
                {
                    name: "type",
                    label: 'Tipo',
                    options: {
                        sort: false,
                    }
                },
                {
                    name: "created_at",
                    label: "Data",
                    options: {
                        customBodyRender: value => (
                            <span>{moment(value).locale('pt-br').format('DD/MM/YYYY HH:mm:ss')}</span>
                        ),
                    }
                },
            ]}
        />
    )
}
